import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();

export const UploadAPIService = {
    get: async function (source) {

        let response;        
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Upload/Get?source=' + source, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    getLogMessages: async function (source) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Upload/GetLogMessages?source=' + source, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    uploadFile: async function (source, file) {
        let response;                
        const formData = new FormData();
        formData.append('file', file);
        try {
            console.log('source:: ' + source);
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Upload?source=' + source
, {
              method: 'POST',
                headers: headers,
                body: formData

            });

            if (response.ok) {
                console.log('File uploaded successfully');
                return await response.json()
            } else {
                
                const errorText = await response.json();
                console.error('Error uploading file:', errorText.message);
                return {
                    error: true,
                    status: response.status,
                    message: errorText.message
                };
            }
        } catch (error) {
            const errorText = await response.json();
            console.error('Error uploading file:', error);
            return {
                error: true,
                status: response.status,
                message: errorText.message
            };
        }
    },

}